import { render } from "./EmotionTool.vue?vue&type=template&id=57cf5dd0&scoped=true"
import script from "./EmotionTool.vue?vue&type=script&lang=ts"
export * from "./EmotionTool.vue?vue&type=script&lang=ts"

import "./EmotionTool.vue?vue&type=style&index=0&id=57cf5dd0&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-57cf5dd0"

export default script